import { apiLabs } from '../../api'

const SentMail = async (body) => {
	const res = await apiLabs.post('recover_sale/qtd/filter', body)
	return res
}

export default SentMail